import { render, staticRenderFns } from "./HelloWorld3.vue?vue&type=template&id=4b6de9fc&scoped=true&"
import script from "./HelloWorld3.vue?vue&type=script&lang=js&"
export * from "./HelloWorld3.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld3.vue?vue&type=style&index=0&id=4b6de9fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6de9fc",
  null
  
)

export default component.exports